export const getTNTIndexableFieldIds = (context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.application.getTNTIndexableFieldIds(
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const getApplicationMetadata = (context?: any) => {
  new Promise((resolve, reject) => {
    window.parent.primingcloud.application.getApplicationMetadata(
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const listParameterNames = (
  allowedDataTypesArray: string[],
  context?: any
) => {
  new Promise((resolve, reject) => {
    window.parent.primingcloud.application.listParameterNames(
      allowedDataTypesArray,
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const getDataTypes = (context?: any) => {
  new Promise((resolve, reject) => {
    window.parent.primingcloud.application.getDataTypes(
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const translateDataTypes = (dataType: string, context?: any) => {
  new Promise((resolve, reject) => {
    window.parent.primingcloud.application.translateDataTypes(
      dataType,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const getBusinessObjectPoolID = (poolName: string, context?: any) => {
  new Promise((resolve, reject) => {
    window.parent.primingcloud.application.getBusinessObjectPoolID(
      poolName,
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const listBusinessobjectPoolNames = (context?: any) => {
  new Promise((resolve, reject) => {
    window.parent.primingcloud.application.listBusinessobjectPoolNames(
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const listCatalogs = (context?: any) => {
  new Promise((resolve, reject) => {
    window.parent.primingcloud.application.listCatalogs(
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const loadCatalog = (id: number, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.application.loadCatalog(
      id,
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const validateDataType = (
  dataType: string,
  value: string,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.application.validateDataType(
      dataType,
      value,
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const listMappingNames = () => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.application.listParameterNames(
      (data: unknown) => resolve(data),
      (err: Error) => reject(err)
    )
  })
}
